import type { ConstValue } from '@bridge/types';

export const FEATURE_FLAGS = {
  AdminFraudRfiSignals: 'adminFraudRfiSignals',
  AdminRfiSelectableItems: 'adminRfiSelectableItems',
  AdminMigrationPrototypes: 'adminMigrationPrototypes',
  AdminSanctionsBlockedDepositActions: 'adminSanctionsBlockedDepositActions',
  DeveloperRejectionDetailSurfacing: 'developerRejectionDetailSurfacing',
  DashboardFixedOutputTransfers: 'fixedOutputTransfersEnabled',
  DashboardFraudReport: 'dashboardFraudReport',
  DashboardVirtualAccountFeeConfig: 'dashboardVirtualAccountFeeConfig',
  DashboardWalletsActivationFunnel: 'dashboardWalletsActivationFunnel',
  ExposeSuggestedExchangeRateForStuckUsdtSells: 'exposeSuggestedExchangeRateForStuckUsdtSells',
  IndexedDepositWebhookEnabled: 'indexedDepositWebhookEnabled',
  IsKycRelianceDeveloper: 'isKycRelianceDeveloper',
  LeadFednowOfframpRollout: 'leadFednowOfframpRollout',
  PersonalSettings: 'personalSettings',
  PylonChat: 'dashboardPylonChat',
  PylonSupport: 'dashboardPylonSupport',
  RequireRelianceDataToTransact: 'requireRelianceDataToTransact',
} as const;

/** Type derived from FEATURE_FLAGS values */
export type FeatureFlag = ConstValue<typeof FEATURE_FLAGS>;
